import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d13d2d34b9ae00146a2a1f/aqarmarket/src/app/sign-up-login-screen/components/AuthClient.tsx");
